import React from 'react';
import { TabTableContainer, Title } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { GridColumns } from '@material-ui/data-grid';
import { formatColWithDate, valueGridMoneyFormatter } from '@components/datagrid/custom.datagrid.props';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { noopArray } from '@domain/utils/function.utils';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { CancelToken } from 'axios';
import { useAuth } from '@domain/auth/auth.hook';
import CustomGridCellVipIcon from '@components/datagrid/custom.grid.cell.vip.icon';
import { useGame } from '@domain/game.selection/game.selection.hook';
import { GameType } from '@domain/game.selection/types/game.type';

const commonsColumns: GridColumns = [
  { field: 'task', headerName: 'Task', width: 190 },
  { field: 'taskParam', headerName: 'Param', width: 120 },
  { field: 'taskCount', headerName: 'Count', width: 115 },
];

const praiaColumns: GridColumns = [
  { field: 'daily', headerName: 'Daily', width: 108 },
  ...commonsColumns,
  { field: 'coins', headerName: 'Coins', width: 120, type: 'number', valueFormatter: valueGridMoneyFormatter },
  { field: 'cash', headerName: 'Cash', width: 120, type: 'number', valueFormatter: valueGridMoneyFormatter },
  { field: 'vip', headerName: 'Vip', width: 97, renderCell: CustomGridCellVipIcon },
  { field: 'startDate', headerName: 'Start Date', ...formatColWithDate, width: 149 },
  { field: 'closureDate', headerName: 'Closure Date', ...formatColWithDate, width: 159 },
];

const rexColumns: GridColumns = [
  ...commonsColumns,
  { field: 'taskId', headerName: 'Task Id', width: 130 },
  { field: 'difficulty', headerName: 'Difficulty', width: 150 },
  { field: 'gameId', headerName: 'Game Id', width: 130 },
];

interface LatestMissionsData {
  id: number;
}

const LatestMissions = () => {
  const game = useGame();
  const { authorizedServices } = useAuth();

  async function runSearch(data: any, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<LatestMissionsData[]>('/admin/daily-missions/list/', { params: { page }, cancelToken });
  }

  const { responseData, pageCount, loading, error } = usePagedData(null, runSearch, { placeholderData: noopArray });

  // const rows = responseData?.map(createData) || [];
  const rows = responseData || [];

  const total = rows.length;

  return (
    <>
      <TabTableContainer>
        <Title>Daily Missions Latest ({total})</Title>
        <MainDataGrid
          columns={game.type === GameType.Praia ? praiaColumns : rexColumns}
          rows={rows}
          loading={loading}
          error={error}
          pageCount={pageCount}
        />
      </TabTableContainer>
    </>
  );
};

export default LatestMissions;
